import React, { useState, useEffect } from "react";
import styled from "styled-components";
import alarmSvg from "../../assets/images/alarm.svg";
import userAvi from "../../assets/images/dummyAvi.svg";
import { RxCaretDown } from "react-icons/rx";
import { useNavigate, Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { FiPackage, FiArrowLeft, FiSearch, FiPlus, FiMinus } from "react-icons/fi";
import { toast } from "react-hot-toast";

const AddServices = () => {
  const navigate = useNavigate();
  const name = JSON.parse(sessionStorage?.getItem("name"));
  const [loading, setLoading] = useState(false);
  const [updatingService, setUpdatingService] = useState(false);
  const [selectedServices, setSelectedServices] = useState([]);
  const [availableServices, setAvailableServices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const token = JSON.parse(sessionStorage.getItem("token"));
  const clientId = JSON.parse(sessionStorage.getItem("clientId2"));

  useEffect(() => {
    fetchAvailableServices();
    fetchUserServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAvailableServices = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `https://services.tm30.net/manager/v1/client/allowedServices`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data.message === "Success") {
        setAvailableServices(data.data || []);
      } else {
        console.error("Failed to fetch available services:", data);
        toast.error("Failed to fetch available services");
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching available services:", error);
      toast.error("Error fetching available services");
      setLoading(false);
    }
  };

  const fetchUserServices = async () => {
    try {
      const response = await fetch(
        `https://services.tm30.net/manager/v1/client/allowedServices/${clientId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data.message === "Success") {
        // Initialize selected services with current user services
        setSelectedServices(data.data || []);
      } else {
        console.error("Failed to fetch user services:", data);
      }
    } catch (error) {
      console.error("Error fetching user services:", error);
    }
  };

  const toggleService = async (service) => {
    try {
      setUpdatingService(service);
      
      const isRemoving = selectedServices.includes(service);
      let response;
      
      if (isRemoving) {
        // Use DELETE method when removing a service
        response = await fetch(
          `https://services.tm30.net/manager/v1/client/allowedServices/${clientId}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              allowedServices: [service],
            }),
          }
        );
      } else {
        // Use POST method when adding a service
        response = await fetch(
          `https://services.tm30.net/manager/v1/client/allowedServices/${clientId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              allowedServices: [...selectedServices, service],
            }),
          }
        );
      }
      
      const data = await response.json();
      if (data.message === "Success") {
        toast.success(isRemoving ? "Service removed" : "Service added");
        // Update local state after successful API call
        setSelectedServices(prev => 
          isRemoving ? prev.filter(s => s !== service) : [...prev, service]
        );
      } else {
        toast.error(data.message || "Failed to update service");
        console.error("Failed to update service:", data);
      }
      
      setUpdatingService(false);
    } catch (error) {
      toast.error("Error updating service");
      console.error("Error updating service:", error);
      setUpdatingService(false);
    }
  };

  const saveServices = () => {
    // Since we're already updating services in real-time, just navigate back to services page
    toast.success("Services updated successfully");
    navigate("/services");
  };

  const isServiceSelected = (service) => {
    return selectedServices.includes(service);
  };
  
  const formatServiceName = (service) => {
    // Replace hyphens with spaces and capitalize first letter
    return service
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const filteredServices = availableServices.filter(service => 
    service.toLowerCase().includes(searchTerm.toLowerCase()) 
  );

  return (
    <Container>
      <div className="head">
        <div className="head_content">
          <img src={alarmSvg} alt="" />
          <div
            className="userProfileWrapper"
            onClick={() => {
              navigate("/dashboard/profile-settings");
            }}
          >
            <img src={userAvi} alt="" />
            <div className="userInfo">
              <p style={{ fontWeight: "bold" }}>{name}</p>
              <p style={{ fontSize: "11px", fontWeight: "bold" }}>User</p>
            </div>
            <RxCaretDown size={17} style={{ color: "#fff" }} />
          </div>
        </div>
      </div>
      <div className="contentWrapper">
        <div className="firstContentHead">
          <p className="pageName">Add Services</p>
        </div>
        <div className="header">
          <p>Browse and add services to your account</p>
          <div className="search-container">
            <FiSearch className="search-icon" size={18} />
            <input 
              type="text" 
              placeholder="Search services..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        <div className="services-container">
          {loading ? (
            <div className="loading-container">
              <div className="skeleton-grid">
                {[1, 2, 3, 4, 5, 6].map((item) => (
                  <div className="skeleton-card" key={item}>
                    <div className="skeleton-header">
                      <Skeleton circle width={48} height={48} />
                      <Skeleton width={60} height={32} />
                    </div>
                    <Skeleton width="70%" height={24} style={{ marginBottom: 8 }} />
                    <Skeleton width="40%" height={16} />
                    <div className="skeleton-footer">
                      <Skeleton width={100} height={16} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : filteredServices.length > 0 ? (
            <>
              <div className="services-grid">
                {filteredServices.map((service) => (
                  <div 
                    className={`service-card ${isServiceSelected(service) ? 'selected' : ''}`} 
                    key={service}
                  >
                    <div className="card-header">
                      <div className="service-icon">
                        <FiPackage size={24} />
                      </div>
                      <button 
                        className={`action-button ${isServiceSelected(service) ? 'remove' : 'add'} ${updatingService === service ? 'updating' : ''}`}
                        onClick={() => !updatingService && toggleService(service)}
                        disabled={updatingService}
                      >
                        {updatingService === service ? (
                          <div className="loading-spinner"></div>
                        ) : isServiceSelected(service) ? (
                          <>
                            <FiMinus size={16} />
                            Remove
                          </>
                        ) : (
                          <>
                            <FiPlus size={16} />
                            Add
                          </>
                        )}
                      </button>
                    </div>
                    <div className="service-details">
                      <h3>{formatServiceName(service)}</h3>
                    </div>
                    <div className="service-status">
                      <div className={`status-indicator ${isServiceSelected(service) ? 'active' : 'inactive'}`}></div>
                      <span>{isServiceSelected(service) ? 'Active' : 'Inactive'}</span>
                    </div>
                  </div>
                ))}
              </div>
              
            </>
          ) : (
            <div className="empty-state">
              <div className="empty-icon">
                <FiPackage size={40} />
              </div>
              <h3>No Services Found</h3>
              <p>We couldn't find any services matching your search criteria.</p>
              {searchTerm && (
                <button 
                  className="clear-search-btn"
                  onClick={() => setSearchTerm("")}
                >
                  Clear Search
                </button>
              )}
            </div>
          )}
        </div>

        <div className="back-button-container">
          <Link to="/services" className="back-button">
            <FiArrowLeft size={18} /> Back to Services
          </Link>
        </div>
      </div>
    </Container>
  );
};

export default AddServices;

const Container = styled.div`
  padding: 30px;
  position: absolute;
  top: 0;
  width: calc(100% - 16%);
  max-width: calc(100% - 16%);

  @media only screen and (max-width: 1147px) {
    width: calc(100%);
    margin-left: 0;
    max-width: calc(100%);
  }
  @media only screen and (max-width: 450px) {
    padding: 0;
  }
  .head {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .head_content {
      display: flex;
      width: 300px;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;

      @media only screen and (max-width: 450px) {
        width: 150px;
      }

      img {
        @media only screen and (max-width: 450px) {
          width: 20px;
        }
      }

      .userProfileWrapper {
        width: 200px;
        border-left: 1px solid #eeebeb;
        padding-left: 40px;
        display: flex;
        align-items: center;
        gap: 15px;
        cursor: pointer;

        @media only screen and (max-width: 450px) {
          width: 100px;
          padding-left: 0;
          margin-top: 20px;
          border-left: 0 solid #eeebeb;
        }

        .userInfo {
          display: flex;
          flex-direction: column;
          gap: 15px;
          color: #fff;

          p {
            @media only screen and (max-width: 450px) {
              font-size: 11px;
            }
          }
        }
        img {
          @media only screen and (max-width: 450px) {
            width: 40px;
          }
        }

        svg {
          @media only screen and (max-width: 450px) {
            display: none;
          }
        }
      }
    }
  }

  .contentWrapper {
    background-color: #fff;
    padding: 20px 0 80px;
    border-radius: 20px;
    margin-top: 50px;

    .firstContentHead {
      display: flex;
      align-items: center;
      padding: 20px;
      justify-content: space-between;
      .pageName {
        font-size: 30px;
        @media only screen and (max-width: 450px) {
          font-size: 18px;
        }
      }
    }

    .header {
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      @media only screen and (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
      }

      p {
        font-weight: 500;
        font-size: 17px;
        @media only screen and (max-width: 450px) {
          font-size: 14px;
        }
      }

      .search-container {
        width: 300px;
        position: relative;
        
        @media only screen and (max-width: 768px) {
          width: 100%;
        }
        
        .search-icon {
          position: absolute;
          left: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          pointer-events: none;
        }
        
        .search-input {
          width: 100%;
          padding: 12px 15px 12px 42px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 14px;
          transition: all 0.2s ease;
          background-color: #f8fafc;
          color: #334155;
          
          &::placeholder {
            color: #94a3b8;
          }
          
          &:focus {
            outline: none;
            border-color: #2563eb;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
            background-color: #fff;
          }
        }
      }
    }

    .services-container {
      padding: 0 20px;
      
      .loading-container {
        padding: 20px 0;
        
        .skeleton-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 20px;
          
          @media only screen and (max-width: 450px) {
            grid-template-columns: 1fr;
          }
        }
        
        .skeleton-card {
          border-radius: 12px;
          padding: 24px;
          display: flex;
          flex-direction: column;
          gap: 16px;
          background-color: #fff;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          
          .skeleton-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
          }
          
          .skeleton-footer {
            margin-top: auto;
            padding-top: 16px;
          }
        }
      }
      
      .services-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 20px;
        
        @media only screen and (max-width: 450px) {
          grid-template-columns: 1fr;
        }
        
        .service-card {
          border: none;
          border-radius: 12px;
          padding: 24px;
          display: flex;
          flex-direction: column;
          gap: 16px;
          transition: all 0.3s ease;
          background-color: #fff;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          position: relative;
          overflow: hidden;
          
          &:hover {
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
          }
          
          &.selected {
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 4px;
              height: 100%;
              background-color: #28a745;
            }
          }
          
          .card-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          
          .service-icon {
            background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
            border-radius: 12px;
            width: 48px;
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #4a5568;
          }
          
          .action-button {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 8px 12px;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s ease;
            border: none;
            
            &.add {
              background-color: #2563eb;
              color: white;
              
              &:hover {
                background-color: #1d4ed8;
              }
            }
            
            &.remove {
              background-color: #f44336;
              color: white;
              
              &:hover:not(:disabled) {
                background-color: #d32f2f;
              }
            }
            
            &:disabled, &.updating {
              opacity: 0.7;
              cursor: not-allowed;
            }
            
            .loading-spinner {
              width: 16px;
              height: 16px;
              border: 2px solid rgba(255, 255, 255, 0.3);
              border-radius: 50%;
              border-top-color: white;
              animation: spin 1s linear infinite;
            }
            
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          }
          
          .service-details {
            h3 {
              margin: 0 0 8px;
              font-size: 18px;
              color: #2d3748;
              font-weight: 600;
            }
            
            .service-type {
              margin: 0;
              font-size: 14px;
              color: #718096;
              font-weight: 400;
            }
          }
          
          .service-status {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-top: 8px;
            
            .status-indicator {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              
              &.active {
                background-color: #28a745;
                box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.2);
              }
              
              &.inactive {
                background-color: #adb5bd;
              }
            }
            
            span {
              font-size: 14px;
              color: #718096;
            }
          }
        }
        }
      }
      
      .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 20px;
        text-align: center;
        
        .empty-icon {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          color: #94a3b8;
        }
        
        h3 {
          margin: 0 0 12px;
          color: #334155;
          font-size: 24px;
          font-weight: 600;
        }
        
        p {
          color: #64748b;
          max-width: 400px;
          margin-bottom: 24px;
          line-height: 1.6;
        }
        
        .clear-search-btn {
          background-color: #2563eb;
          color: white;
          padding: 12px 24px;
          border-radius: 8px;
          border: none;
          text-decoration: none;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 6px rgba(37, 99, 235, 0.2);
          
          &:hover {
            background-color: #1d4ed8;
            transform: translateY(-2px);
            box-shadow: 0 6px 12px rgba(37, 99, 235, 0.25);
          }
          
          &:active {
            transform: translateY(0);
            box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
          }
        }
      }
    }
    
    .save-button-container {
      display: flex;
      justify-content: center;
      margin-top: 40px;
      
      .save-button {
        background-color: #2563eb;
        color: white;
        padding: 14px 36px;
        border-radius: 8px;
        border: none;
        font-weight: 600;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 10px;
        box-shadow: 0 4px 6px rgba(37, 99, 235, 0.2);
        
        &:hover:not(:disabled) {
          background-color: #1d4ed8;
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(37, 99, 235, 0.25);
        }
        
        &:active:not(:disabled) {
          transform: translateY(0);
          box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
        }
        
        &:disabled {
          background-color: #93c5fd;
          cursor: not-allowed;
          box-shadow: none;
        }
        
        .spinner {
          animation: spin 1s linear infinite;
        }
      }
    }
    
    .back-button-container {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      
      .back-button {
        background-color: transparent;
        color: #64748b;
        padding: 12px 25px;
        border-radius: 8px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        border: 1px solid #e2e8f0;
        
        &:hover {
          background-color: #f8fafc;
          color: #334155;
        }
      }
    }
  }
`;
